import getFullWebCdnUrl from "@/utils/getFullWebCdnUrl";

export enum UserOpenBrokerStatus {
  NO_COMMIT_MATERIAL = 1, // 未提交材料
  COMMIT_MATERIAL = 2, // 提交材料
  OPEN_ACCOUNT = 3, // 材料通过 入金否未知
  DEPOSITED = 4, // 已100
  REBATE = 6, // 返佣金中
  UN_REBATE = 7, // 活动前已入金达标，不参与返佣
}

export enum DepositInvitedUserStatus {
  DEPOSIT_FAIL = 401, // 401 已入金未达标，任务失败
  COMPLETE_AWARD = 402, // 402 已完成入金任务，为你赢得了一次入金奖励
  COMPLETE_NOT_AWARD = 403, // 403 已入金已达标，但是来晚了一步呜呜！
  BEFORE_DEPOSIT = 7, // 活动前已入金达标，不参与活动
}

export enum SendPrizeStatus {
  NO_SEND = 1, // 未发放
  SENDED = 2, // 已发放
  WAIT_SEND = 4, // 等待领取
}

export enum GetOpportunityTypes {
  REGISTER = 1, // 注册
  OPEN_BROKER_ACCOUNT = 2, //开户
  DEPOSIT = 3, // 存入资金
  INVITE_FRIEND = 4, // 邀请好友入金
}

export interface Prize {
  awardId: number;
  awardName: string;
  price: number;
  title: string;
  icon: string;
  color: string;
}

export interface PrizeRecord {
  id: string;
  awardId: number;
  awardName: string;
  awardStatus: SendPrizeStatus;
  createTime: number;
  price: number;
}

export interface OpportunityRecord {
  taskType: GetOpportunityTypes;
  invitee: string;
  opportunitiesCount: number;
  createTime: number;
}

export interface MarqueeRecord {
  awardId: number;
  name: string;
}

export interface InviteModel {
  invitee: string; // 用户账户
  inviteTime: string; // 邀请时间
  inviteeStatus: number; // 邀请进度
  avatar: string;
}

export interface ResponseInviteModel {
  registeredCount: number; // 待开户人数
  accountOpenedAccount: number; // 待入金人数
  depositCompletedCount: number; // 已入金人数
  rebatingFriends: number; // 返佣好友
  inviteList: InviteModel[];
}

export interface ResponseRebateCommission {
  acquired: number; // 获得佣金
  released: number; // 已发放的佣金
  records: CommissionRecord[];
}

export interface CommissionRecord {
  commissionId: number;
  commission: number;
  name: string;
  avatar: string;
  createTime: string;
}

export enum DepositAwardWay {
  NOT_FIRST_DEPOSIT = 2,
  FIRST_DEPOSIT = 3,
}
export enum DepositRewardStatus {
  CAN_NOT_CLAIM = 0,
  NOT_CLAIM = 1,
  CLAIMED = 2,
  WAIT_GET = 3,
}
export interface DepositRewardStockModel {
  awardRecordId: number;
  status: DepositRewardStatus; // 领取状态 0：无法领取  1：未领取  2：已领取
  tradingCount: number;
  price: number;
  awardName: string;
  awardWay: DepositAwardWay; //2 非首次入金   3 首次入金
}

export enum FirstDepositQualificationsStatus {
  deposited_before = 0, //  0 活动前已入金
  deposited_not_award = 1, // 1 用户入金未达标
  deposited_award = 2, // 2 用户入金已达标
  not_deposit = 3, // 3 待入金
}
export interface DepositRewardResponse {
  stockAwards: DepositRewardStockModel[];
  achievementsNumber: number; // 大于1则代表完成多次入金邀请。
  firstDepositQualificationsStatus: number;
}
// 装盘奖池 顺序对应转盘位置
export const WHEEL_PRIZE_LIST: Prize[] = [
  {
    awardId: 6,
    awardName: "APPLE",
    price: 160,
    title: "Apple",
    icon: getFullWebCdnUrl("/pulling-new/stock-apple.webp"),
    color: "#FFF9E7",
  },
  {
    awardId: 5,
    awardName: "SE",
    price: 75,
    title: "Sea",
    icon: getFullWebCdnUrl("/pulling-new/stock-sea.webp"),
    color: "#DCEBFF",
  },
  {
    awardId: 4,
    awardName: "Snapchat",
    price: 10,
    title: "SNAP",
    icon: getFullWebCdnUrl("/pulling-new/stock-snapchat.webp"),
    color: "#FFF9E7",
  },
  {
    awardId: 3,
    awardName: "PINS",
    price: 20,
    title: "Pinterest",
    icon: getFullWebCdnUrl("/pulling-new/stock-pinterest.webp"),
    color: "#FFEEEE",
  },
  {
    awardId: 7,
    awardName: "EMBK",
    price: 0.5,
    title: "EMBK",
    icon: getFullWebCdnUrl("/pulling-new/stock-embk.webp"),
    color: "#FFF9E7",
  },
  {
    awardId: 2,
    awardName: "GRAB",
    price: 3,
    title: "Grab",
    icon: getFullWebCdnUrl("/pulling-new/stock-grab.webp"),
    color: "#F1FFD9",
  },
];

export const PRIZE_LIST = [
  ...WHEEL_PRIZE_LIST,
  // 历史股票卡
  {
    awardId: 1,
    awardName: "SNDL",
    price: 0.3,
    title: "Sundial",
    icon: getFullWebCdnUrl("/pulling-new/stock-sundial.webp"),
    color: "#E3FCFF",
  },
];
